import i18n from '@/locales'

export const getAccountingPeriodFilter = ({ field = 'month' } = {}) => {
  return {
    label: i18n.t('bill.accounting_period'),
    filter: true,
    formatter: val => {
      return `${field}.contains('${val}')`
    },
  }
}

export const getContractNumberFilter = ({ field = 'offering_class' } = {}) => {
  return {
    label: i18n.t('bill.contract_number'),
    filter: true,
    formatter: val => {
      return `${field}.contains('${val}')`
    },
  }
}

export const getServiceDescriptionFilter = ({ field = 'category' } = {}) => {
  return {
    label: i18n.t('bill.service_description'),
    filter: true,
    formatter: val => {
      return `${field}.contains('${val}')`
    },
  }
}

export const getRegionFilter = ({ field = 'cpp_region' } = {}) => {
  return {
    label: i18n.t('bill.text_83'),
    dropdown: true,
    multiple: true,
    distinctField: {
      type: 'field',
      key: field,
    },
  }
}

export const getOsTypeFilter = ({ field = 'os_type' } = {}) => {
  return {
    label: i18n.t('table.title.os'),
    dropdown: true,
    multiple: false,
    items: [
      { label: 'Windows', key: 'Windows' },
      { label: 'Linux', key: 'Linux' },
    ],
    filter: true,
    formatter: val => {
      return `spec.contains('${val}')`
    },
  }
}

export const getModelFilter = ({ field = 'os_sku' } = {}) => {
  return {
    label: i18n.t('bill.model'),
    filter: true,
    formatter: val => {
      return `spec.contains('${val}')`
    },
  }
}
